import { STATUS } from '#constants/status';
import { STEPS_STATUS_IDS } from '#models/general/steps/constants';

export const mapAddWash = ({ washData = {}, washId = '' }) => [JSON.stringify(washData), washId];

export const mapUpdateWashStep = params => ({
  ...params?.washData,
  dateAndTimeCharged: params?.washData?.washRunDateAndTime,
  [STEPS_STATUS_IDS.WASH]: STATUS.COMPLETED,
  [STEPS_STATUS_IDS.SPIRIT]: STATUS.IN_PROGRESS
});
